<div class="container-fluid mt-4">

  <div class="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
    <h4 class="mb-0">{{'ISSUE.TITLE' | translate}}</h4>
    <div class="d-flex flex-wrap align-items-center gap-3">
      <div class="form-check mb-0">
        <input class="form-check-input" type="checkbox" id="includeClosed"
               [checked]="includeClosed" (change)="toggleClosed()">
        <label class="form-check-label" for="includeClosed">
          {{'ISSUE.SHOW_CLOSED' | translate}}
        </label>
      </div>
      <button type="button" class="btn btn-primary" (click)="openReport()">
        {{'ISSUE.REPORT' | translate}}
      </button>
    </div>
  </div>

  @if (errorCode) {
    <div class="alert alert-warning" role="alert">
      {{('ISSUE.ERROR.' + errorCode) | translate}}
    </div>
  }

  @if (loading) {
    <p class="text-muted">{{'ISSUE.LOADING' | translate}}</p>
  } @else if (!errorCode && issues.length === 0) {
    <p class="text-muted">
      {{(includeClosed ? 'ISSUE.NONE' : 'ISSUE.NONE_OPEN') | translate}}
    </p>
  } @else if (!errorCode) {
    <div class="table-responsive">
      <table class="table table-hover align-middle">
        <thead>
          <tr>
            <th scope="col">{{'ISSUE.COL_TITLE' | translate}}</th>
            <th scope="col">{{'ISSUE.COL_STATUS' | translate}}</th>
            <th scope="col">{{'ISSUE.COL_PRIORITY' | translate}}</th>
            <th scope="col">{{'ISSUE.COL_REPORTER' | translate}}</th>
            <th scope="col">{{'ISSUE.COL_CREATED' | translate}}</th>
          </tr>
        </thead>
        <tbody>
          @for (issue of issues; track issue.id) {
            <tr>
              <td>
                <div class="fw-semibold">{{issue.title}}</div>
                @if (issue.description) {
                  <div class="text-muted small">{{issue.description}}</div>
                }
              </td>
              <td>
                <span class="badge" [class.bg-secondary]="isClosed(issue)"
                      [class.bg-success]="!isClosed(issue)">{{issue.status || '-'}}</span>
              </td>
              <td>
                <!--
                  Gold, and only here. The design system reserves it for
                  emphasis, so it marks the one row state a reader is scanning
                  for -- a high-priority issue -- rather than decorating the
                  column. Everything else prints as plain text.
                -->
                @if (isHighPriority(issue)) {
                  <span class="priority-high">
                    <lucide-icon name="star" size="14"></lucide-icon>
                    {{issue.priority}}
                  </span>
                } @else {
                  {{issue.priority || '-'}}
                }
              </td>
              <td>{{issue.reporter || '-'}}</td>
              <td>{{issue.createdAt ? (issue.createdAt | date:'yyyy-MM-dd') : '-'}}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>

<!--
  The report dialog. An ng-template rather than its own component: it has no
  logic of its own, and a second component would need declaring, registering and
  wiring for three form fields.
-->
<ng-template #reportDialog let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{'ISSUE.REPORT' | translate}}</h5>
    <button type="button" class="btn-close" [attr.aria-label]="'ISSUE.CANCEL' | translate"
            (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <label class="form-label" for="issueTitle">{{'ISSUE.FIELD_TITLE' | translate}}</label>
      <input id="issueTitle" class="form-control" type="text" maxlength="200"
             [(ngModel)]="title" name="title" autocomplete="off">
    </div>
    <div class="mb-3">
      <label class="form-label" for="issueDescription">{{'ISSUE.FIELD_DESCRIPTION' | translate}}</label>
      <textarea id="issueDescription" class="form-control" rows="6" maxlength="10000"
                [(ngModel)]="description" name="description"
                [attr.placeholder]="'ISSUE.DESCRIPTION_HINT' | translate"></textarea>
    </div>
    <div class="mb-3">
      <label class="form-label" for="issuePriority">{{'ISSUE.FIELD_PRIORITY' | translate}}</label>
      <select id="issuePriority" class="form-select" [(ngModel)]="priority" name="priority">
        <option value="low">{{'ISSUE.PRIORITY_LOW' | translate}}</option>
        <option value="medium">{{'ISSUE.PRIORITY_MEDIUM' | translate}}</option>
        <option value="high">{{'ISSUE.PRIORITY_HIGH' | translate}}</option>
      </select>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">
      {{'ISSUE.CANCEL' | translate}}
    </button>
    <button type="button" class="btn btn-primary"
            [disabled]="submitting || !title.trim() || !description.trim()"
            (click)="submitReport(modal)">
      {{(submitting ? 'ISSUE.SUBMITTING' : 'ISSUE.SUBMIT') | translate}}
    </button>
  </div>
</ng-template>
